export default __webpack_public_path__ + "static/media/avanishMundra.7cfab8d3.svg";